import { Component, OnInit, signal } from '@angular/core';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent implements OnInit {
  // Señal para almacenar el correo electrónico del usuario
  public userEmail = signal('');
  
  ngOnInit(): void {
    // Intenta obtener los datos del usuario desde sessionStorage
    const clienteData = localStorage.getItem('cliente');
    if (clienteData) {
      try {
        const cliente = JSON.parse(clienteData);
        // Asigna el correo electrónico a la señal si existe
        if (cliente && cliente.email) {
          this.userEmail.set(cliente.email);
        }
      } catch (e) {
        console.error('Error al parsear los datos del cliente de localStorage:', e);
      }
    }
  }

  /**
   * Maneja la lógica de cerrar sesión.
   * Por ahora, solo es un placeholder.
   */
  public logout(): void {
    console.log('Cerrando la sesión del usuario...');
    // Aquí puedes agregar la lógica para desautenticar al usuario,
    // limpiar el token y redirigir a la página de inicio de sesión.
  }
}
